<template>
  <Modal v-bind="$attrs" @open="onModalOpen" @cancel="emits('cancel')" @confirm="onConfirm">
    <el-form
      label-width="80px"
      v-if="currentRow"
      ref="formRef"
      class="ghost-button-styles"
      @submit.native.prevent
      :model="planForm"
      :rules="rules"
    >
      <el-form-item label="目标出价" prop="cpa_bid">
        <el-radio-group v-model="planForm.bid_type">
          <el-radio-button ghost :label="BID_VALUE_TYPE.FIXED"> 固定出价 </el-radio-button>
          <el-radio-button ghost :label="BID_VALUE_TYPE.RANGE"> 随机区间出价 </el-radio-button>
        </el-radio-group>
        <div style="margin-top: 10px">
          <el-input
            v-if="planForm.bid_type === BID_VALUE_TYPE.FIXED"
            v-model="planForm.cpa_bid"
            style="width: 320px"
            placeholder="0.1 ~ 10000元"
          ></el-input>
          <InputRange v-else v-model="planForm.bid_num_range" placeholder="金额"> </InputRange>
        </div>
      </el-form-item>
      <el-form-item label="ROI系数" prop="roi_goal" v-if="adDeepBidVisible">
        <el-radio-group v-model="planForm.roi_bid_type">
          <el-radio-button ghost :label="BID_VALUE_TYPE.FIXED"> 固定出价 </el-radio-button>
          <el-radio-button ghost :label="BID_VALUE_TYPE.RANGE"> 随机区间出价 </el-radio-button>
        </el-radio-group>
        <div style="margin-top: 10px">
          <el-input
            v-if="planForm.roi_bid_type === BID_VALUE_TYPE.FIXED"
            v-model="planForm.roi_goal"
            style="width: 320px"
            placeholder="0.0001 ~ 5"
          ></el-input>
          <InputRange v-else v-model="planForm.roi_bid_num_range"> </InputRange>
        </div>
      </el-form-item>
    </el-form>
  </Modal>
</template>

<script setup>
import { ref, toRefs } from 'vue'
import { BID_VALUE_TYPE } from '../../../consts/index.js'
import { needDeepRoiGoal } from '@/views/create/bytedance/hooks/utils/plan.js'
import { useOptimizeGoalRelative } from '@/views/create/bytedance/hooks/useOptimizeGoal.js'
import Modal from '@/views/create/gdt/components/distribute/components/modal.vue'
import InputRange from '@/views/edit/kuaishou/components/input-range'
import { getPlanFormRules } from '@/views/create/bytedance/rules/index.js'
// eslint-disable-next-line
const emits = defineEmits(['cancel', 'confirm'])
// eslint-disable-next-line
const props = defineProps({
  currentRow: Object
})
const { currentRow } = toRefs(props)
const formRef = ref(null)
const rules = ref({})
const planForm = ref({})
const projectForm = ref({})

const { adDeepBidVisible } = useOptimizeGoalRelative(projectForm)

function onModalOpen() {
  planForm.value = {
    // 初始化出价接收值，可被当前设置的值覆盖
    roi_bid_num_range: [],
    bid_num_range: [],
    cpa_bid: '',
    roi_goal: '',
    ...currentRow.value.creative_params
  }

  const { deep_bid_type } = currentRow.value.outer_plan_params.delivery_setting
  // 构造deep_bid_type，用于是否显示roi系数
  projectForm.value = {
    ...currentRow.value.outer_plan_params,
    delivery_setting: {
      optimize_goal: { deep_bid_type }
    }
  }
  rules.value = getPlanFormRules.call({ planForm: planForm.value, projectForm: projectForm.value })
}
function onConfirm() {
  formRef.value.validate((valid) => {
    if (valid) {
      const { bid_type, cpa_bid, bid_num_range, roi_goal, roi_bid_type, roi_bid_num_range, ...restParams } = planForm.value
      const creative_params = {
        ...restParams,
        bid_type
      }

      if (bid_type === BID_VALUE_TYPE.FIXED) {
        creative_params.cpa_bid = Number(cpa_bid)
      }

      if (bid_type === BID_VALUE_TYPE.RANGE) {
        creative_params.bid_range = 1
        creative_params.bid_num_range = bid_num_range.map(Number)
      }

      const { deep_bid_type } = currentRow.value.outer_plan_params.delivery_setting
      if (needDeepRoiGoal(deep_bid_type)) {
        creative_params.roi_bid_type = roi_bid_type
        if (roi_bid_type === BID_VALUE_TYPE.FIXED) {
          creative_params.roi_goal = Number(roi_goal)
        }
        if (roi_bid_type === BID_VALUE_TYPE.RANGE) {
          creative_params.roi_bid_range = 1
          creative_params.roi_bid_num_range = roi_bid_num_range.map(Number)
        }
      }
      emits('confirm', creative_params)
    }
  })
}
</script>

<style lang="scss" scoped>
</style>
